import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSessionStorage } from "helpers/SessionConfig";
import API from "utils/api";

export const monerisCardGet = createAsyncThunk(
  "moneris/cardGet",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`/monerisCustomerCardList/${bodyParams}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const monerisCardCreate = createAsyncThunk(
  "moneris/cardCreate",
  async (formData, thunkAPI) => {
    try {
      const response = await API.post(`/createCustomerMoneris`, formData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const paymentGetSwitch = createAsyncThunk(
  "payment/switch",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`/getsettingspaymentswitch/${getSessionStorage("EMPLOYEEID")}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const paymentOptionUpdate = createAsyncThunk(
  "payment/option",
  async (formData, thunkAPI) => {
    try {
      const response = await API.post(`/createsettingspaymentswitch`, formData);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
